import React from 'react';
import PropsTypes from 'prop-types';
import { alpha, Box } from '@mui/material';
import { useSidebarContext } from '../../../../utility/AppContextProvider/SidebarContextProvider';
import { Colors, SPACING } from 'shared/constants/AppEnums';
import { grey } from '@mui/material/colors';

const HeaderNavWrapper = ({ children }) => {
  const {
    sidebarBgColor,
    sidebarTextColor,
    sidebarMenuSelectedBgColor,
    sidebarMenuSelectedTextColor,
  } = useSidebarContext();
  return (
    <Box
      sx={{
        backgroundColor: grey[50],
        color: sidebarTextColor,
        py: 2.5,
        '& .navbarNav': {
          display: 'flex',
          padding: 0,
        },
        '& .navItem': {
          width: 'auto',
          cursor: 'pointer',
          py: 1,
          px: { xs: 4, lg: 5 },
          borderRadius: 3,
          '&.active': {
            color: `${Colors.white} !important`,
            backgroundColor: Colors.primary,
            '& .navLinkIcon': {
              borderRadius: 2,
              backgroundColor: Colors.white,
              color: Colors.primary,
            },
            '& .AppNavLinkTextSubmenu': {
              color: Colors.white,
            }
          },
        },
        '& .navLinkIcon': {
          mr: 2.5,
          color: 'inherit',
          fontSize: 24,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        },
      }}
    >
      {children}
    </Box>
  );
};

export default HeaderNavWrapper;

HeaderNavWrapper.propTypes = {
  children: PropsTypes.node,
};
